<template>
  <div class="app-wrapper" :class="classObj">
    <sidebar class="sidebar-container"></sidebar>
    <div class="main-container">
      <navbar></navbar>
      <app-main></app-main>
    </div>
  </div>
</template>

<script>
import { Navbar, Sidebar, AppMain } from "./components";
import ResizeMixin from "./mixin/ResizeHandler";
import { queryList } from "@/api/traceBatch.js";
import { list } from '@/api/platform.js'

export default {
  name: "layout",
  components: {
    Navbar,
    Sidebar,
    AppMain,
  },
  provide() {
    return {
      reaciveBadgeValue: () => this.FinalBadge,
      reacivePlatValue: ()=> this.PlatBadge,
      reaciveTestValue: ()=> this.TestBadge
    };
  },
  data() {
    return {
      interval: null,
      FinalBadge: 0,
      PlatBadge:0,
      TestBadge:0,
      listQuery: {
        brandName: "",
        proName: "",
        state: "1",
        page: 1,
        limit: 9999,
      },
    };
  },
  mixins: [ResizeMixin],
  computed: {
    sidebar() {
      return this.$store.state.app.sidebar;
    },
    device() {
      return this.$store.state.app.device;
    },
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === "mobile",
      };
    },
  },
  /* 挂载完毕后启动计时器来持续获取到未审批的数量,
       可以选择在登出账户后清除计时器。
       定义一个 全局 timer (this.$store.state.app.FinalInterVal)
    */
  mounted() {
    clearInterval(this.$store.state.app.FinalInterVal)
    this.getBadgeValue()
    this.getPlatFormValue()
    // this.getTestValue()
    this.interval = setInterval(()=>{
      this.getBadgeValue(),this.getPlatFormValue()
    }, 60000);
    this.$store.dispatch("SetFinalInterValue", this.interval);
  },
  methods: {
    getBadgeValue() {
      // let query = this.listQuery

      this.listQuery.parentId = this.$store.state.user.merchantId;
      this.listQuery.state = "1"
      const query = JSON.stringify(this.listQuery)
      queryList(query)
        .then((res) => {
          // console.log(res,'list');
          const arr = res.retData.data.filter((item) => {
            return item.state == "1";
          });
          this.FinalBadge = arr.length;
          // console.log(this.FinalBadge,'list');
        })
        .catch(() => {
          this.FinalBadge = 0;
        });
    },
    getPlatFormValue(){
      const q = this.listQuery
      q.state = "5"
      // console.log(q);
      list(q).then((result) => {
        this.PlatBadge = result.retData.count
        q.state ="6"
        this.getTestValue(q)
      }).catch((err) => {
        this.PlatBadge = 0
      });
    },
    getTestValue(query){
      list(query).then((result) => {
        this.TestBadge = result.retData.count
      }).catch((err) => {
        this.TestBadge = 0
      });
    }
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "src/styles/mixin.scss";
.app-wrapper {
  @include clearfix;
  position: relative;
  height: 100%;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/Layout.vue